module.exports = __webpack_public_path__ + "static/media/chaos_knight.253c137e.png";